import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageDownloadButton = React.memo(() => {
  const { t } = useTranslation()
  const { onDownloadPDF } = useProductPageContext()

  return (
    <Button
      id="product-page__download-button"
      variant={ButtonVariant.SECONDARY}
      disabled={!onDownloadPDF}
      onClick={onDownloadPDF}
      icon={IconName.DOWNLOAD}
    >
      {t("Product.Share")}
    </Button>
  )
})
